import { TypeaheadService } from "../../../../typeahead/typeahead.service";

var color = [];
var colorNames = [];

var index = 0;

var colorPickerJS = (function() {

    var allColor;

    var ua = window.navigator.userAgent;
    var is_ie = /MSIE|Trident/.test(ua);

    if (is_ie) {
        //IE specific code goes here

        // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
        if (!String.prototype.padStart) {
            String.prototype.padStart = function padStart(targetLength, padString) {
                targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
                padString = String((typeof padString !== 'undefined' ? padString : ' '));
                if (this.length > targetLength) {
                    return String(this);
                } else {
                    targetLength = targetLength - this.length;
                    if (targetLength > padString.length) {
                        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
                    }
                    return padString.slice(0, targetLength) + String(this);
                }
            };
        }

        if (!String.prototype.repeat) {
            String.prototype.repeat = function(count) {
                'use strict';
                if (this == null) {
                    throw new TypeError('can\'t convert ' + this + ' to object');
                }
                var str = '' + this;
                count = +count;
                if (count != count) {
                    count = 0;
                }
                if (count < 0) {
                    throw new RangeError('repeat count must be non-negative');
                }
                if (count == Infinity) {
                    throw new RangeError('repeat count must be less than infinity');
                }
                count = Math.floor(count);
                if (str.length == 0 || count == 0) {
                    return '';
                }
                // Ensuring count is a 31-bit integer allows us to heavily optimize the
                // main part. But anyway, most current (August 2014) browsers can't handle
                // strings 1 << 28 chars or longer, so:
                if (str.length * count >= 1 << 28) {
                    throw new RangeError('repeat count must not overflow maximum string size');
                }
                var rpt = '';
                for (var i = 0; i < count; i++) {
                    rpt += str;
                }
                return rpt;
            }
        }
    }

    function getLifeColorNames() {
        $.ajax({
            url: '/ajaxGetColorsByPalette?palette_id=2'
        }).done(function(colorPalette) {
            allColor = colorPalette;
            getLifeColorNamesFromColorPalette(colorPalette)
            setCorolSearch(colorPalette);
        });
    }


    var localData = {
        className: null,
        id: null,
        colorPalette: null
    }

    function matchLocalData(className, id) {
        return className === localData.className && id == localData.id && localData.colorPalette && localData.colorPalette.length > 0;
    }

    function checkOpen(name) {
        var root = $('body');

        if (name) {
            var parent = $('input[name=' + name + ']').closest('.color-picker-component');
            if (parent.length)
                root = parent;
        }

        return root.find('.slick-list:visible').length > 0;
    }



    function getResult(className, id, name) {
        if (!id) {
            id = window.useDefaultcolorPaletteIdInPageBuilder || 2;
        }
        if (checkOpen(name))
            return;
        if (!matchLocalData(className, id)) {
            $.ajax({
                url: '/ajaxGetColorsByPalette?palette_id=' + id,
            }).done(function(colorPalette) {
                localData.className = className;
                localData.id = id;
                localData.colorPalette = colorPalette;
                drawColorPalette(localData.colorPalette, className, name);
                setCorolSearch(localData.colorPalette, name);
            });
        } else {
            drawColorPalette(localData.colorPalette, className, name);
            setCorolSearch(localData.colorPalette, name);
        }



    }

    var lifeRegexp = /^([0-9])+$/

    var mosaikRegexp = /^(M)([0-9])+$/

    function getLifeColorNamesFromColorPalette(colorPalette) {
        if (colorPalette != null) {
            for (var i = 0; i < colorPalette.length; i++) {
                var names = { id: '', name: '' };

                names.id = colorPalette[i].id;
                names.name = colorPalette[i].name;

                if (names.name.length > 0) {
                    colorNames.push(names);
                }
            }
        }
    }

    function drawColorPalette(colorPalette, className, name) {
        if (colorPalette != null) {


            if (className) {
                className = '.' + className
            } else {
                className = ''
            }

            //console.log(colorPalette);

            var mosaik = colorPalette.filter(function(elem) {
                return mosaikRegexp.test(elem.name);
            });

            var root = $('body');

            if (name) {
                var parent = $('input[name=' + name + ']').closest('.color-picker-component');
                if (parent.length)
                    root = parent;
            }

            color = [];


            root.find('.color-selection').html('');

            for (var i = 0; i < 116; i++) {
                var shade = colorPalette.filter(function(elem) {
                    return elem.name.indexOf((i + 1).toString().padStart(3, '0')) == 0
                });

                if (shade.length > 0) {
                    color.push(shade);
                }
            }

            color.forEach(function(shade) {
                var row = $('<div class="item"><div class="palette-row"><div class="palette-color"></div></div></div>');
                shade.forEach(function(item) {
                    var elem = $('<div class="color" data-hex=""></div>');

                    if (item.name == '0019') {
                        elem.addClass('white');
                    }

                    elem.css('background-color', '#' + item.hex).html(item.name).attr('data-hex', item.hex);
                    row.find('.palette-color').append(elem);
                });
                root.find('.color-palette' + className + ' .color-selection.life').append(row);
            });

            var mosaikIndex = 0;

            while (mosaikIndex < mosaik.length) {
                var row;

                if (mosaikIndex % 3 == 0) {
                    row = $('<div class="item"><div class="palette-row"><div class="palette-color"></div></div></div>');
                    root.find('.color-palette' + className + ' .color-selection.mosaik').append(row);
                }

                var elem = $('<div class="color" data-img-url=""></div>');
                elem.css('background', 'url(' + mosaik[mosaikIndex].imageUrl + ')').html(mosaik[mosaikIndex].name).attr('data-img-url', mosaik[mosaikIndex].imageUrl);
                row.find('.palette-color').append(elem);

                mosaikIndex++;
            }

            drawSlick(className.split('.')[1], root);
            root.find('.colorName').addClass('visible');
        }
    }

    function getBgColorHex(elem) {
        var color = elem.css('background-color')
        var hex;
        if (color.indexOf('#') > -1) {
            hex = color;
        } else {
            var rgb = color.match(/\d+/g);
            hex = '#' + ('0' + parseInt(rgb[0], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2);
        }
        return hex;
    }

    function drawColorDetail(colorCode, parent) {
        $('.color-detail .color-image').removeClass('white');

        var colors = $('.palette-color .color').toArray();
        var i = 0;

        while (i < colors.length && $(colors[i]).html() != colorCode) {
            i++;
        }

        var elem = $(colors[i]);
        var color = elem.html();

        if (color) {

            var first = color.substring(0, 1);
            var background = elem.css('background-color');
            var rgb = background.replace(/rgb|\(|\)/g, '').replace(/\, /g, '/');
            var hex = getBgColorHex(elem);

            if (parent)
                parent.find('.color-detail').addClass('visible');
            else
                $('.color-detail').addClass('visible');
            // $('.colorName').addClass('visible');

            if (mosaikRegexp.test(color) && first == 'M') {
                $('.color-detail .color-image').css('background', 'url("/images/products/color-selection/' + color + '.jpg") left top no-repeat transparent');
                $('.color-detail .color-name').html(color);
                $('.color-detail .color-code').hide();
            } else if (lifeRegexp.test(color)) {
                if (color == '0019') {
                    $('.color-detail .color-image').addClass('white');
                }

                $('.color-detail .color-image').css('background', 'none left top no-repeat ' + background);
                $('.color-detail .color-name').html(color);
                $('.color-detail .color-code').show();
                $('.color-detail .color-code span.hex').html(hex);
                $('.color-detail .color-code span.rgb').html(rgb);
            }
        }
    }

    function appendColorPalette() {
        setTimeout(function() {
            $('.form-component').append($('.color-palette'));

            var form = $('.form-component');

            $('.color-palette').css({
                'pointer-events': 'all',
                'position': 'absolute',
                'z-index': 1000,
                'width': form.width(),
                'top': form.position().top,
                'left': form.position().left
            });
        }, 1000);
    }

    function drawSlick(className, root) {
        if (!root) {
            root = $('body');
        }
        root.find('.color-selection').html();

        if (className) {
            className = '.' + className
        } else {
            className = ''
        }

        if (root.find('.color-palette' + className + ' .color-selection.life').length > 0) {



            root.find('.color-palette' + className + ' .szinminta-carousel').show();
            try {
                root.find('.color-palette' + className + ' .color-selection.life').slick({
                    dots: false,
                    infinite: true,
                    centerMode: false,
                    rows: 0,
                    slidesToShow: 19,
                    slidesToScroll: 19,
                    responsive: [{
                            breakpoint: 1280,
                            settings: {
                                slidesToShow: 15,
                                slidesToScroll: 15
                            }
                        },
                        {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 9,
                                slidesToScroll: 9
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 5
                            }
                        }
                    ]
                });

                root.find('.color-palette' + className + ' .color-selection.mosaik').slick({
                    dots: false,
                    infinite: true,
                    centerMode: false,
                    rows: 0,
                    slidesToShow: 6,
                    slidesToScroll: 6
                });
            } catch (ex) {}

            root.find('.color-palette' + className + ' .szinminta-carousel').css('opacity', 1);

            setTimeout(function() {
                root.find('.color-palette' + className).css('pointer-events', 'all');
            }, 300);
        }
    }

    function destroySlick(className) {
        $('.color-palette' + className + ' .color-selection.life').slick('destroy');
        $('.color-palette' + className + ' .color-selection.life').html('');
        $('.colorName').removeClass('visible');
        $("#colorNameFormBuilder").typeahead("destroy");

    }

    function
    getSlick(className, id, name) {
        getResult(className, id, name);
    }

    function goToSlick(color, className) {
        if (className) {
            className = '.' + className
        } else {
            className = ''
        }

        var carousel = $('.color-palette' + className + ' .color-selection');
        var hex = $('.item:not(.slick-cloned) .color:contains(' + color + ')').attr('data-hex');
        var index = $('.item:not(.slick-cloned) .color:contains(' + color + ')').closest('.item').attr('data-slick-index');

        carousel[0].slick.slickGoTo(parseInt(index));

        data.facade.color = String(color);
        data.facade.hex = hex;
    }

    function markColor(color, className) {
        if (className) {
            className = '.' + className
        } else {
            className = ''
        }

        $('.color-palette' + className + ' .palette-color .color').removeClass('black');

        var colors = $('.color-palette' + className + ' .palette-color .color').toArray();
        var i = 0;

        while (i < colors.length && $(colors[i]).html() != color) {
            i++;
        }

        var elem = $(colors[i]);

        if (elem.html() == color) {
            elem.addClass('black');
        }
    }

    function setCorolSearch(colorPalette) {

        TypeaheadService.setupTypeaheadLocal('input#colorNameFormBuilder',
            colorPalette,
            'name',
            false,
            null,
            null,
            function(data) {
                return '<div class="color-select-option"><div class="name"><p>' + data.name + '</p></div><div class="color" style="background-color: #' + data.hex + '"></div></div>';
            }
        )
    };



    $(document).on('click', '.color-picker', function(ev) {
        getSlick('', '', $(ev.target).attr('name'));
    });

    $(document).on('click', '.colorName .color-select-option', function(ev) {

        var root = $(event.target).closest('.color-picker-component');
        if (root.length == 0) {
            root = $('body');
        }
        root.find('.color-detail-background').show();
        var color = $(this).text();

        root.find('.color-picker').attr('value', color);
        root.find('#colorNameFormBuilder').val(color).trigger('input');
        drawColorDetail(color, root);
    });


    $(document).on('click', '.color-selection.life .color', function() {
        var root = $(event.target).closest('.color-picker-component');
        if (root.length == 0) {
            root = $('body');
        }
        root.find('.color-detail-background').show();

        var color = $(this).text();

        root.find('.color-picker').attr('value', color);
        root.find('#colorNameFormBuilder').val(color).trigger('input');
        //root.find('#colorNameFormBuilder').typeahead('val', color);
        drawColorDetail(color, root);
    });

    $(document).on('click', '.color-detail, .close-button, .color-detail-background', function() {
        $('.color-detail-background').hide();
        $('.color-detail').removeClass('visible');
        // $('.colorName').removeClass('visible');
    });

    $(document).on('click', '.szinminta-carousel-close:not(.calculator-style)', function(ev) {
        var root = $(event.target).closest('.color-picker-component');
        if (root.length == 0) {
            root = $('body');
        }

        root.find('.color-detail-background').hide();
        root.find('.color-detail').removeClass('visible');
        root.find('.colorName').removeClass('visible');
        root.find('.szinminta-carousel').css('opacity', 0);

        setTimeout(function() {
            root.find('.szinminta-carousel').hide();
            try {
                root.find('.color-selection.life').slick('destroy');
            } catch (ex) {}
        }, 500);
    });

    return {
        getResult: getResult,
        getLifeColorNames: getLifeColorNames,
        drawColorPalette: drawColorPalette,
        getBgColorHex: getBgColorHex,
        drawColorDetail: drawColorDetail,
        appendColorPalette: appendColorPalette,
        getSlick: getSlick,
        drawSlick: drawSlick,
        goToSlick: goToSlick,
        destroySlick: destroySlick,
        markColor: markColor
    }
})();

window.colorPickerJS = colorPickerJS;
window.colorPickerPalette = color;
window.colorPickerPaletteNames = colorNames;

$(document).ready(function() {

    if ($('.form-component').length > 0) {
        colorPickerJS.appendColorPalette();
    }

});

export default colorPickerJS;